var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "search_bar"
  }, [_c('div', {
    staticClass: "search_input_wrapper"
  }, [_c('v-btn', {
    attrs: {
      "color": "#fff",
      "loading": _vm.isAjax,
      "depressed": ""
    },
    on: {
      "click": _vm.search
    }
  }, [_c('fa', {
    attrs: {
      "icon": "search"
    }
  })], 1), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.searchValue,
      expression: "searchValue"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.searchValue
    },
    on: {
      "keyup": [function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search($event);
      }, function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.closeSearch($event);
      }],
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.searchValue = $event.target.value;
      }, _vm.oninput],
      "focus": _vm.onfocus,
      "blur": _vm.onblur
    }
  })], 1), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_vm.showResults ? _c('div', {
    staticClass: "search_results"
  }, [_vm.isAjax ? _c('div', {
    staticClass: "no_result"
  }, [_c('p', [_vm._v("Searching...")])]) : _c('div', [_vm.results === null ? _c('div', {
    staticClass: "no_result"
  }, [_c('p', {
    staticClass: "icon"
  }, [_c('fa', {
    attrs: {
      "icon": "snowman"
    }
  })], 1), _c('p', [_vm._v("No Results Found")])]) : _vm._e(), _vm._l(_vm.results, function (res) {
    return _c('search-result', {
      key: _vm.getKey(res),
      staticClass: "search_result",
      attrs: {
        "item": res
      },
      nativeOn: {
        "click": function click($event) {
          return _vm.onSelectResult(res);
        }
      }
    });
  })], 2)]) : _vm._e()])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }